import { AnyAction } from "redux";
import { PMS_CONNECT_FAILURE, PMS_CONNECT_REQUEST, PMS_CONNECT_SUCCESS } from "../constants/pms-connect.constant";

const initialState = {
    loading: false,
    data: [],
    error: '',
};

export const pmsConnectReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case PMS_CONNECT_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case PMS_CONNECT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case PMS_CONNECT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}